<div class="unauthenticated">

  <div class="main-panel">

    <div class="container" *ngIf = "!maintenance ; else maintenanceDiv" >
      
      <div class="row py-4 my-4">

        <div class="col-md-6">

          <div class="login-message">
            <div class="row justify-content-center pb-4">
              <div class="col-md-3 mx-2">
                <img class="akibaLogo" src="assets/img/miahorro.svg">
              </div>
              <div class="col-md-8 py-4 my-2">
                <h2>Bienvenido a Mi Ahorro</h2>
              </div>
              <div class="col-md-1">
              </div>
            </div>
            <div class="text-lefth alert alert-info pt-4 mt-4" style="color:#004085; text-align: center;" >
              <h4 >IMPORTANTE</h4>
              <p><b>¿Es la primera vez que ingresas </b> o <b> has olvidado tu contraseña?</b>
                <br>
                Es necesario que <b>generes una contraseña nueva,</b><br>
                dando
                <button type="button" onclick="location.href ='/olvide-mi-contrasena';" class="btn btn-outline-warning m-2" style="background-color:#feffef;">
                  <b>Clic aqui. </b>
                </button>
              </p>
            </div>
          </div>

        </div>

        <div class="col-md-1"></div>

        <div class="col-md-5">

          <div class="card card-signup">

            <div class="header text-center" data-background-color="rose">
              <h2>Acceder</h2>
            </div>

            <p class="text-divider"></p>

            <div class="content">
              <div class="row px-2">

                <div class="col-md-2">
                  <mat-icon matSuffix>person</mat-icon>
                </div>

                <div class="col-md-10">
                  <mat-form-field>
                    <input matInput placeholder="Ingresa tu número de Colaborador" [(ngModel)]="model.employeeNumber"
                      #employeeNumber="ngModel" type="text" name="employeeNumber" required>
                    <mat-error *ngIf="employeeNumber?.errors?.required">Es necesario que ingreses tu número de
                      Colaborador</mat-error>
                  </mat-form-field>
                </div>

              </div>

              <mat-divider class="my-4 mx-4"></mat-divider>

              <div class="row px-2">

                <div class="col-md-2">
                  <mat-icon matSuffix>lock</mat-icon>
                </div>

                <div class="col-md-10">
                  <mat-form-field>
                    <input matInput placeholder="Ingresa tu contraseña" [(ngModel)]="model.password" #password="ngModel"
                      type="password" name="password" required>
                    <mat-error *ngIf="password?.errors?.required">Es necesario que ingreses tu contraseña</mat-error>
                  </mat-form-field>
                </div>

              </div>

              <div class="row my-4">
                <div class="col-md-12">
                  <button class="btn btn-block btn-primary" (click)="onEnter()">Ingresar</button>
                </div>
              </div>

            </div>

          </div>

          <div class="text-center mt-2">Ver. {{version}}</div>

        </div>
      </div>

      <div class="row p-4 m-4" style="justify-content: center;">
        <div class="col-md-5">
          <h5>¿Tienes problemas o dudas? Llámanos</h5>
          <p>
            Contact Center: 01 800 701 4270 Opciones: 2 - 1
          </p>
        </div>
      </div>

    </div>

    <ng-template #maintenanceDiv>
      <div class="container">
        <div class="row justify-content-center">
          <div class= "col-md-8">
            <img class="scale-with-grid" style= "width:100%;" src="assets/img/mantenimientoBimbo.jpg">
          </div>  
        </div>
      </div>
    </ng-template>


  </div>

</div>